// extracted by mini-css-extract-plugin
module.exports = {"insights":"Insights2020__insights__KEIxf","insightsItem":"Insights2020__insightsItem__nH-bf","insightsItemDismissed":"Insights2020__insightsItemDismissed__NAVmP"};